import PollOption from '@effectivastudio/lit-components/components/poll_option/element.js';
import OrganizeOption from '@effectivastudio/lit-components/components/organize_option/element.js';
import DateOption from '@effectivastudio/lit-components/components/date_option/element.js';

PollOption.config = {
  icons: {
    check: 'check:solid',
    minus: 'check:solid',
    plus: '',
  },
  hideActionWhenDisabled: false,
};

DateOption.config = {
  icons: {
    check: 'check:solid',
    minus: 'check:solid',
    plus: '',
  },
  hideActionWhenDisabled: false,
};

OrganizeOption.config.hideActionWhenDisabled = true;
